import { format } from 'date-fns';
import { AprovaLiveIcon } from 'morpheus-ui';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatTime } from '../../../../../core/commom/formatTime';
import { Typography } from '../../../../../core/components/molecules/Typography';
import ContentCard from '../../../../../core/components/organism/ContentCard';
import { LiveClass } from '../../../models/LiveClassDto.model';

interface iAprovaLiveContentCardProps {
  item: LiveClass;
  selected?: boolean;
  origin?: 'challenge' | 'live';
  onDone?: (id: string, slug: string) => void | Promise<void>;
}

function AprovaLiveContentCard({
  item,
  selected = false,
  origin,
  onDone,
}: iAprovaLiveContentCardProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMarkingDone, setIsMarkingDone] = useState(false);

  async function handleDone(id: string, slug: string) {
    if (!onDone || isMarkingDone) return;

    try {
      setIsMarkingDone(true);
      await onDone(id, slug);
    } finally {
      setIsMarkingDone(false);
    }
  }

  return (
    <ContentCard
      id={item._id}
      content={origin === 'challenge' ? 'Desafio 60 dias' : 'Aprova Live'}
      discipline={item.area?.title}
      disciplineSlug={item.area?.slug}
      title={item.title}
      slug={item.slug}
      action={() => {
        const pathname = origin === 'challenge'
          ? `/ao-vivo/desafio-60-dias/${item.slug}`
          : `/ao-vivo/aprova-live/${item.slug}`;

        navigate({ pathname, search: location.search });
      }}
      selected={selected}
      showDone={true}
      done={item.done}
      onDone={handleDone}
      doneLoading={isMarkingDone}
      showFavorite={false}
      icon={AprovaLiveIcon}
      color='default'
    >
      <Typography size='small'>
        {item.duration ? `${formatTime(item.duration)} · ` : ''}
        {`${item.teacher ? `${item.teacher} ` : ''}Gravada em ${format(
          new Date(item.startDate),
          'dd/MM/yyyy'
        )}`}
      </Typography>
    </ContentCard>
  );
}

export { AprovaLiveContentCard };
